module.exports = __webpack_public_path__ + "static/media/BH-Hades-Gold.e44e58c6.png";